import { SalaryType } from 'src/graphql/generated';
import { PayType } from 'src/types/salaryTypes';

export const mapUISalaryTypeToHirer = (
  payType: string,
): SalaryType | undefined => {
  switch (payType) {
    case PayType.ANNUAL_PACKAGE:
      return SalaryType.ANNUAL_PACKAGE;
    case PayType.MONTHLY:
      return SalaryType.MONTHLY;
    case PayType.HOURLY_RATE:
      return SalaryType.HOURLY_RATE;
    case PayType.ANNUAL_COMMISSION:
      return SalaryType.ANNUAL_COMMISSION;
  }
};
